import { render, staticRenderFns } from "./PdvLayout.vue?vue&type=template&id=62b1e5f4"
import script from "./PdvLayout.vue?vue&type=script&lang=js"
export * from "./PdvLayout.vue?vue&type=script&lang=js"
import style0 from "./PdvLayout.vue?vue&type=style&index=0&id=62b1e5f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports